/* global axios */
import ApiClient from './ApiClient';

class WahaIntegrationsAPI extends ApiClient {
  constructor() {
    super('waha_integrations', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, {
      inbox_name: data.inboxName,
      device_name: data.deviceName,
      waha_server_url: data.wahaServerUrl,
      waha_api_key: data.wahaApiKey,
      chatwoot_url: data.chatwootUrl,
      activate_webhook: data.activateWebhook,
    });
  }

  delete(id, params) {
    return axios.delete(`${this.url}/${id}`, {
      params: {
        waha_server_url: params.wahaServerUrl,
        waha_api_key: params.wahaApiKey,
      },
    });
  }

  getSessionStatus(sessionName) {
    return axios.get(`${this.url}/session/${sessionName}/status`);
  }

  getQRCode(sessionName) {
    return axios.get(`${this.url}/session/${sessionName}/qr`);
  }

  startSession(sessionName) {
    return axios.post(`${this.url}/session/${sessionName}/start`);
  }

  stopSession(sessionName) {
    return axios.post(`${this.url}/session/${sessionName}/stop`);
  }

  restartSession(sessionName) {
    return axios.post(`${this.url}/session/${sessionName}/restart`);
  }

  logoutSession(sessionName) {
    return axios.post(`${this.url}/session/${sessionName}/logout`);
  }

  getSessionMe(sessionName) {
    return axios.get(`${this.url}/session/${sessionName}/me`);
  }

  requestPairingCode(sessionName, phoneNumber) {
    return axios.post(`${this.url}/session/${sessionName}/pairing-code`, {
      phone_number: phoneNumber,
    });
  }

  getProfile(sessionName) {
    return axios.get(`${this.url}/session/${sessionName}/profile`);
  }

  updateProfileName(sessionName, name) {
    return axios.put(`${this.url}/session/${sessionName}/profile/name`, {
      name,
    });
  }

  updateProfileStatus(sessionName, status) {
    return axios.put(`${this.url}/session/${sessionName}/profile/status`, {
      status,
    });
  }

  getTimelock(sessionName) {
    return axios.get(`${this.url}/session/${sessionName}/timelock`);
  }

  getCapping(sessionName) {
    return axios.get(`${this.url}/session/${sessionName}/capping`);
  }

  sendTextStatus(sessionName, data) {
    return axios.post(`${this.url}/session/${sessionName}/status/text`, {
      text: data.text,
      background_color: data.backgroundColor,
      font: data.font,
    });
  }

  sendMediaStatus(sessionName, mediaType, data) {
    return axios.post(`${this.url}/session/${sessionName}/status/media`, {
      media_type: mediaType,
      file_url: data.fileUrl,
      file_data: data.fileData,
      file_name: data.fileName,
      file_mimetype: data.fileMimetype,
      caption: data.caption,
      background_color: data.backgroundColor,
    });
  }

  getStatuses(sessionName) {
    return axios.get(`${this.url}/session/${sessionName}/status/list`);
  }

  deleteStatus(sessionName, statusId) {
    return axios.post(`${this.url}/session/${sessionName}/status/delete`, {
      status_id: statusId,
    });
  }

  sendCommand(inboxId, command) {
    return axios.post(`${this.url}/${inboxId}/send_command`, {
      command,
    });
  }
}

export default new WahaIntegrationsAPI();
